<template>
  <div>
    <div class="driverManagementBox relative">
      <page-title
        :right-btns="rightBtns"
        @rightClick="rightClickHandler"
      ></page-title>
      <div class="innerLeft mt-4">
            <ra-search-box
              :search-fields="driverSearchFields"
              @search="searchDriversHandler"
              @clear="clearDriverHandler"
            ></ra-search-box>
            <div class="driversTable"  v-loading="driversLoading">
              <div class="innerTop">
                <div class="outTable mt-4"  v-if="driverList.length > 0">
                  <el-table
                    :data="driverList"
                    style="width: 100%;font-weight: normal;">
                    <el-table-column
                      width="55">
                      <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                          <img class="w-4" src="../../assets/activate.png" alt="">
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="(item, index) in driverColumn"
                      :label="item.label"
                      :prop="item.prop"
                      :key="index"
                      :width="item.minWidth"
                      @click="driverDetialOpen"
                    >
                      <template slot-scope="scope">
                        <ra-render
                          v-if="item.render"
                          :row="scope.row"
                          :render="item.render"/>
                        <span v-else>{{scope.row[item.prop]}}</span>
<!--                        <span>{{scope.row[item.prop]}}</span>-->
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="Actions"
                      prop="actions"
                      width="200"
                      header-align="center"
                      align="center">
                      <template slot-scope="scope">
                        <div class="action" style="cursor: pointer">
                         <span  v-if="scope.row.status == 1" @click="driverActiveHandle(3,scope.row)">
                            <img class="w-4 mr-2" src="../../assets/zipCode/activate@2x.png" alt="">
                          </span>
                          <span  v-else @click="driverActiveHandle(2,scope.row)">
                            <img class="w-4 mr-2" src="../../assets/zipCode/ban@2x.png" alt="">
                          </span>
                          <span  @click="driverActiveHandle(1,scope.row)">
                        <img class="w-4 mr-2" src="../../assets/zipCode/delete@2x.png" alt="">
                        </span>
                          <span @click="driverEditHandle(scope.row)">
                          <img class="w-4" src="../../assets/zipCode/edit@2x.png" alt="">
                        </span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <table-empty v-else></table-empty>
              </div>
            </div>
            <ra-pagination
              :current-page="driverPage"
              :total="totalDrivers"
              :items-per-page="driversPerPage"
              @page-change="handleDriverPageChange"
            ></ra-pagination>
      </div>
    </div>
<!--    删除、激活等-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="driverDeleteTitle"
      :visible.sync="driverDeleteDialog"
      width="35%">
      <div class="addInner" v-if="driverDelete == 1" style="margin-top: 24px">
        Will you delete this driver?  The driver cannot access to Rapidi anymore.
      </div>
      <div class="addInner" v-if="driverDelete == 3" style="margin-top: 24px">
        Will you deactivate this driver? The driver cannot access to Rapidi until his(her) account is activated again.
      </div>
      <div class="addInner" v-if="driverDelete == 2" style="margin-top: 24px">
        Will you activate this driver?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px" class="changeFocus"  @click="driverDeleteDialog = false">No</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="driverConfirmDelete">Yes</el-button>
  </span>
    </el-dialog>
<!--  新增编辑-->
    <driver-new-and-edit @updateList="updateListHandle" :driverInfo="driverInfo" :driverTitle="driverTitle" ref="driver_edit_add"></driver-new-and-edit>
<!--    司机详情-->
    <driver-detail
        @edit="editHandler"
        @command="commandHandler"
        ref="driverDetail" :driverInfo="driverInfo"></driver-detail>
  </div>
</template>

<script>
// Import statements for custom components and assets would go here

import DriverNewAndEdit from "@/view/driver/driver-new-and-edit.vue";
import {deleteDriver, getDriverList, updateDriverStatus} from "@/api/driver";
import DriverDetail from "@/view/driver/driverDetail.vue";

export default {
  components: {DriverDetail, DriverNewAndEdit},
  data() {
    return {
      driverActiveTab: 'drivers',
      driverSearchFields: [{
        type: 'selectInput',
        prop: 'search_value',
        label: '',
        selectKey: 'search_key',
        placeholder: 'Search..',
        width: '150',
        options: [
          { label: "Driver's name", value: 'name' },
          { label: 'Cellphone No.', value: 'phone' },
          { label: 'Email', value: 'email' },
        ]
      },
        {
          type: 'input',
          prop: 'ma_code',
          label: 'MA Code',
          placeholder: 'Search..',
        },
        {
          type: 'input',
          prop: 'zone_code',
          label: 'Zone Code',
          placeholder: 'Search..',
          options: [
          ]
        },],
      driverList: [],
      driversLoading: false,
      driverPage: 1,
      totalDrivers: 10,
      driversPerPage: 10,
      rightBtns: [
        {
          label: 'NEW',
          name: 'new',
          bgColor: '#e95646',
        }
      ],
      driverColumn:[
        { label: "Driver's name", prop: "name",minWidth:260, render: (h, params) => {
            return (<span class="cursor-pointer" on-click={() => this.nameHandler(params.row)}>{params.row.name}</span>)
          }},
        { label: "Cellphone No.", prop: "phone_num",minWidth:260},
        { label: "MA Code", prop: "ma_code" ,minWidth:260},
        { label: "Zone Code", prop: "zone_codes_text"},
      ],
      driverDeleteTitle:"Delete this driver",
      driverDeleteDialog:false,
      driverDelete:1,
      driverSelectItem:'',
      initSearch:{
        search:'name',
        search_value:'',
        ma_code:'',
        zone_code:''
      },
      driverTitle:'',
      driverInfo:{},
    };
  },
  created() {
    this.initSearch.page = this.driverPage;
    this.initSearch.limit = 10
    this.getDriverListHandle(this.initSearch)
  },
  methods: {
    getDriverListHandle(query){
      this.driversLoading = true
      getDriverList(query).then(res=>{
        this.driversLoading = false
        if (res.code == 200){
          this.driverList = res.data.list
          this.driverList.forEach((item)=>{
            item.phone_num = '+'+item.phone_code + ' ' + item.phone
          })
          console.log(this.driverList,'driverList')
          this.totalDrivers = res.data.total
        }else {
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      })
    },
    updateListHandle(){
      console.log('进来了吗')
      this.$refs.driverDetail.driverDialogVisible = false
      this.getDriverListHandle()
    },
    searchDriversHandler(query) {
      query.page = this.driverPage;
      query.limit = 10
      this.initSearch = query;
      this.getDriverListHandle(query)
    },
    clearDriverHandler(query) {
      query.page = this.driverPage;
      query.limit = 10
      this.initSearch = query;
      this.getDriverListHandle(query)
    },
    handleDriverPageChange(page) {
      this.driverPage = page;
      this.getDriverListHandle(this.initSearch);
    },

    rightClickHandler(){
      this.driverTitle = 'Create a driver'
       this.$refs.driver_edit_add.driverDialogFormVisible = true
      this.$refs.driver_edit_add.driverForm.sin_type= 'Individual'
      this.$refs.driver_edit_add.driverForm.residency_status= 'Work permit'

    },
    // 激活司机处理函数
    driverActiveHandle(num,row) {
      this.driverDelete  = num
      this.driverSelectItem = row
      //1 删除 3不激活 2激活
      if (num == 1){
        this.driverDeleteTitle='Delete this driver'
      }else if(num == 3){
        this.driverDeleteTitle='Deactivate this driver'
      }else {
        this.driverDeleteTitle='Activate this driver'
      }
      this.driverDeleteDialog = true
    },
    driverDetialOpen(){

    },
    // 编辑司机处理函数
    driverEditHandle(row) {
      this.driverTitle = 'Edit a driver'
      this.driverInfo = row
      console.log(this.driverInfo,'driverInfo')
      this.$refs.driver_edit_add.driverDialogFormVisible = true
      this.$refs.driver_edit_add.changeImgLabelHanlde(this.driverInfo.residency_status)
    },
    driverConfirmDelete(){
       if (this.driverDelete == 3 || this.driverDelete == 2){
         updateDriverStatus({
           id:this.driverSelectItem.id,
           status:this.driverSelectItem.status == 0?1:0
         }).then(res=>{
           this.driverDeleteDialog = false
           this.$refs.driverDetail.driverDialogVisible = false
           if (res.code == 200){
             this.getDriverListHandle(this.initSearch)
             this.$message({
               type:"success",
               message:this.driverSelectItem.status == 0?'Successfully activated': 'Successfully deactivated'
             })
           } else {
             this.$message({
               type:"error",
               message:res.msg
             })
           }
         })
       }else {
         deleteDriver({
           id:this.driverSelectItem.id,
         }).then(res=>{
           this.driverDeleteDialog = false
           this.$refs.driverDetail.driverDialogVisible = false
           if (res.code == 200){
             this.getDriverListHandle(this.initSearch)
             this.$message({
               type:"success",
               message:'Successfully deleted'
             })
           }else {
             this.$message({
               type:'error',
               message:res.msg
             })
           }
         })
       }
    },
    nameHandler(row) {
      this.$refs.driverDetail.driverDialogVisible = true
      this.driverInfo = row
    },
    editHandler(row) {
      this.driverEditHandle(row)
    },
    commandHandler(command) {
      if (command === 'delete') {
        this.driverActiveHandle(1, this.driverInfo)
      }
      if (command === 'active') {
        this.driverActiveHandle(2, this.driverInfo)
      }
      if (command === 'deactive') {
        this.driverActiveHandle(3, this.driverInfo)
      }
    }
  },
};
</script>

<style scoped lang="less">
.driver_detail{

}
</style>
